<template>
  <main class="container">
    <div class="row text-left mb-2">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <h3 class="text-color-orange font-size-24">
          <span class="span-hr-orange-left"></span>PENJUALAN TERLARIS
        </h3>
        <!-- <p class="font-size-15">Testimoni dari SMA 1 Indonesia</p> -->
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <button type="button" class="btn btn-orange float-right used-product">
          LIHAT PRODUK TERLARIS
        </button>
        <button type="button" class="btn mr-2 float-right reload">
          <i class="fa fa-refresh mr-2" aria-hidden="true"></i> Muat Ulang
        </button>
      </div>
    </div>  
    <div class="item">
      <div class="row">
        <div
          class="col-md-6 mb-4"
          v-for="(item, index) in best_seller"
          :key="`best_seller_${index}`"
        >
          <router-link
            :to="`/kewirausahaan/detail-barang/${item.id}`"
            class="card"
          >
            <div class="row p-2">
              <div class="col-md-6 col-lg-6 col-xs-12">
                <div
                  class="image"
                  :style="{
                    background: 'url(' + item.image + ')',
                  }"
                ></div>
              </div>
              <div class="col-md-6 col-lg-6 col-xs-12">
                <div class="title">
                  {{ item.title.slice(0, 70) + `...` }}
                </div>
                <div class="border-bottom mb-2 mt-2"></div>
                <div class="d-flex align-items-center">
                  <div class="store-icon mr-2">
                    <img
                      class="img-fluid rounded-circle"
                      :src="item.merchant.logo"
                      alt=""
                    />
                  </div>

                  <div class="name-store">
                    {{ item.merchant.name }}
                  </div>
                </div>
                <div class="border-bottom mb-2 mt-2"></div>
                <div class="row">
                  <div class="col-md-6 col-xs-6">
                    <div class="sold">Terjual {{ item.sold }}</div>
                  </div>
                  <div class="col-md-6 col-xs-6">
                    <div class="price float-right">
                      Rp{{ formatNumber(item.price) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import broker from "../../../../utils/broker";
import numeral from "numeral";

export default {
  name: "PenjualanTerlaris",
  data() {
    return {
      items: [1, 2, 3, 4],
      best_seller: [],
      title:
        "TOPI Capten GAMING motif Minecraft warna hijau tosca dan abu abu biru muda",
    };
  },
  mounted() {
    this.getDataBestSeller();
  },
  methods: {
    getDataBestSeller() {
      let self = this;
      broker.fetch
        .get(`/webschool/enterpreneur/goodies/best-seller?limit=4`)
        .then((res) => {
          res.data.data.forEach((item) => {
            self.best_seller.push(item);
          });
        });
    },
    formatNumber(value) {
      let formatted = numeral(value).format("0,0");
      return formatted;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/4-sections/_kewirausahaan_template_3.scss";
</style>
<style lang="scss" scoped>
.container {
  .reload {
    color: #f0542d;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
  }
  .used-product {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
  }

  .item {
    .card {
      border: 1px solid #f4f4f4;
      box-sizing: border-box;
      box-shadow: 1px 4px 19px rgba(75, 75, 75, 0.08);

      .title {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 128.2%;
        color: #525252;
      }

      .sold {
        border: 1px solid #ffc886;
        box-sizing: border-box;
        text-align: center;
      }

      .price {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        color: #f0542d;
      }
      .store-icon {
        width: 16px;
      }
    }
  }
}
@media (min-width: 768px) {
  main {
    padding: 2% 0% 2% 0% !important;
  }
}
</style>
